import { axiosInstance } from 'shared/api';

export type SendLinkErrorCode =
    | 'invalid_email'
    | 'candidate_not_found'
    | 'send_failed'
    | 'rate_limited'
    | 'unknown';

export class SendLinkError extends Error {
    constructor(public errorCode: SendLinkErrorCode) {
        super(errorCode);
        this.name = 'SendLinkError';
    }
}

export async function sendPortalLink(email: string): Promise<void> {
    try {
        await axiosInstance.post('diagnostics/candidate-portal/send-link', { email });
    } catch (error) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const axiosError = error as any;
        const response = axiosError?.response;

        if (!response) {
            throw new SendLinkError('unknown');
        }

        if (response.status === 429) {
            throw new SendLinkError('rate_limited');
        }

        if (response.status === 400) {
            const contentType = response.headers?.['content-type'] || '';

            if (contentType.includes('application/json')) {
                const errorData = response.data;

                if (errorData?.errorCode === '100004') {
                    throw new SendLinkError('candidate_not_found');
                }

                if (errorData?.errorCode === '100087') {
                    throw new SendLinkError('send_failed');
                }
            }

            throw new SendLinkError('invalid_email');
        }

        throw new SendLinkError('unknown');
    }
}
